<template>
  <div class="address">
    <div class="address_title">
      <div v-on:click="xreturn">
        <img src="../../images/dir_left.png" />
      </div>地址管理
    </div>

    <div class="address_div1">
      <div class="address_div" v-for="(item,index) in list" :key="index">
        <div
          class="address_div_right"
          v-on:click="address(
					item.id, item.phone, item.name, item.address, item.addr, item.default,
				)"
        >
          <img src="../../images/write.png" />
        </div>
        <div class="address_div_left" v-on:click="status(item, index)">
          <div>
            收货人：{{item.name}}
            <span>{{item.phone}}</span>
            <i v-model="item.default" v-if="item.default == 1">默认</i>
          </div>
          <div>{{item.addr}}&nbsp;&nbsp;&nbsp;{{item.address}}</div>
        </div>
      </div>
    </div>

    <button class="new" v-on:click="newaddress">新增地址</button>
  </div>
</template>

<script>
import API from "../../lmj_Api/api";
export default {
  data() {
    return {
      name: "addressmanagement",
      list: [],
      uid: this.$store.getters.get_user_id
    };
  },
  mounted() {
    var that = this;
    that.init();
  },
  beforeRouteEnter(to, from, next) {
    var that = this;
    next(vm => {
      console.log(from, "sj"); // 上一页面的路由信息

      if (from.name == "shoppingcart" || from.name == "hyhome") {
        localStorage.to = from.name;
        localStorage.id = from.params.id;
      }
      console.log(localStorage.to, "上一个进入的页面"); // 上一页面的路由信息
    });
  },

  //方法
  methods: {
    //新增地址
    newaddress() {
      this.$router.push({ path: "/nwaddress" });
    },
    xreturn() {
      console.log(localStorage.to, "上一个进入的页面"); // 上一页面的路由信息
      if (localStorage.to == "shoppingcart") {
        // this.$router.push({path:'/shoppingcart'});
        this.$router.push({
          name: "shoppingcart",
          params: {
            id: localStorage.id
          }
        });
      } else if (localStorage.to == "hyhome") {
        this.$router.push({ path: "/hyhome" });
      } else {
        this.$router.go(-1);
      }
    },
    // 获取用户的地址列表项
    init() {
      var that = this;
      var url = API.address;
      this.axios
        .post(url, {
          user_id: that.uid
        })
        .then(res => {
          console.log(res);
          if (res.data.code == 200) {
            that.list = res.data.data;
          }
        });
    },

    // 修改操作地址页
    address(address_id, phone, name, address, addr, status) {
      console.log(address_id, phone, name, address, addr, status);
      this.$router.push({
        name: "addresseditor",
        params: {
          id: address_id,
          phone: phone,
          name: name,
          address: address,
          addr: addr,
          status: status
        }
      });
    },

    // 点击当前地址改变 默认收货地址
    status(obj, index) {
      var i,
        that = this,
        status = 1,
        url = API.addressSave,
        _data = {
          name: obj.name,
          phone: obj.phone,
          addr: obj.addr,
          address: obj.address,
          id: obj.id,
          default: status
        };

      for (i = 0; that.list.length > i; i++) {
        that.list[i].default = 0;
      }
      that.list[index].default = 1;
      console.log(that.list);
      that.axios.post(url, _data).then(res => {
        if (res.data.code == 200) {
          setTimeout(() => {
            that.xreturn();
            // 	that.$router.push({
            // 	name: 'shoppingcart',
            // 	params: {
            // 		id: localStorage.id
            // 	}
            // });
          }, 700);
        }
        console.log(res, 111);
      });
    }
  }
};
</script>
<style lang="less" scoped>
.address_title {
  width: 7.5rem;
  height: 0.88rem;
  z-index: 999;
  background: linear-gradient(
    90deg,
    rgba(123, 212, 255, 1) 0%,
    rgba(92, 186, 255, 1) 100%
  );
  font-size: 0.3rem;
  font-family: PingFangSC-Medium, PingFang SC;
  color: rgba(255, 255, 255, 1);
  text-align: center;
  line-height: 0.88rem;
  position: fixed;
  top: 0;
  left: 0;  
}

.address_title > div {
  width: 1.06rem;
  height: 100%;
  line-height: 0.88rem;
  position: absolute;
  left: 0rem;
  top: 0rem;
  text-align: center;
}

.address_title > div > img {
  width: 0.18rem;
  height: 0.34rem;
  display: inline-block;
  vertical-align: middle;
}

.address_div {
  border-bottom: 0.01rem solid rgba(237, 237, 237, 1);
  width: 100%;
  height: 1.7rem;
  overflow: hidden;
}

.address_div_right {
  float: right;
  height: 100%;
  line-height: 1.7rem;
  padding: 0 0.32rem;
}

.address_div_right > img {
  width: 0.36rem;
  height: 0.36rem;
  // display: inline-block;
  vertical-align: middle;
}

.address_div_left {
  margin-left: 0.3rem;
  margin-top: 0.36rem;
  height: 0.88rem;
  width: 6rem;
  font-size: 0.28rem;
  color: rgba(109, 109, 109, 1);
  :nth-child(1) {
    margin-bottom: 0.1rem;
  }
}

.address_div_left > div > i {
  font-style: normal;
  width: 0.64rem;
  height: 0.32rem;
  background: linear-gradient(
    90deg,
    rgba(123, 212, 255, 1) 0%,
    rgba(92, 186, 255, 1) 100%
  );
  border-radius: 0.1rem;
  font-size: 0.2rem;
  font-family: PingFangSC-Medium, PingFang SC;
  color: rgba(255, 255, 255, 1);
  display: inline-block;
  vertical-align: text-top;
  text-align: center;
  line-height: 0.32rem;
  margin-left: 0.18rem;
}

.address_div_left > div > span {
  margin-left: 0.2rem;
}

//中部内容添加滚动条 处理移动端浏览器不同一
.address_div1::-webkit-scrollbar {
  display: none;
}
.address_div1 {
  width: 7.5rem;
  overflow: hidden;
  overflow-y: scroll;
  -webkit-overflow-scrolling: touch;
  overflow-x: hidden;
  height: calc(~"(100% - (1.08rem + 0.88rem))");
  margin: 0.88rem 0 1.08rem 0;
}

.new {
  width: 7.5rem;
  height: 1.08rem;
  background: linear-gradient(
    90deg,
    rgba(123, 212, 255, 1) 0%,
    rgba(92, 186, 255, 1) 100%
  );
  font-size: 0.32rem;
  font-family: PingFangSC-Medium, PingFang SC;
  color: rgba(255, 255, 255, 1);
  line-height: 1.08rem;
  position: fixed;
  bottom: 0rem;
  left: 0rem;
  outline: none;
  border: 0rem;
}
</style>



// WEBPACK FOOTER //
// src/components/xy/addressmanagement.vue